import { render, staticRenderFns } from "./onboardingVP2.vue?vue&type=template&id=77da3124&scoped=true"
import script from "./onboardingVP2.vue?vue&type=script&lang=js"
export * from "./onboardingVP2.vue?vue&type=script&lang=js"
import style0 from "./onboardingVP2.vue?vue&type=style&index=0&id=77da3124&prod&lang=scss&scoped=true"
import style1 from "./onboardingVP2.vue?vue&type=style&index=1&id=77da3124&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77da3124",
  null
  
)

export default component.exports